import IcSearch from "@/assets/common/ic_search_bold.svg?react";

export interface SearchInputProps {
  onChange?: (value: string) => void;
  value?: string;
  onSearch?: (value: string) => void;
  placeholder?: string;
  className?: string;
  inputClassName?: string;
}

function SearchInput(props: SearchInputProps) {
  const { onChange, value, onSearch, placeholder, className, inputClassName } = props;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.value);
  };

  const handleSearch = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      onSearch?.(e.currentTarget.value);
    }
  };

  return (
    <div className={`relative w-85.5 h-9 m-t-3 ${className}`}>
      <IcSearch className="absolute w-4 h-4 left-4 top-2.5" />
      <input
        type="text"
        placeholder={placeholder}
        className={`p-l-11 w-full h-full mx-input-base bg-#F4F6F9 bg-#F4F6F9 rd-2.5 ${inputClassName}`}
        value={value}
        onChange={handleChange}
        onKeyDown={handleSearch}
      />
    </div>
  );
}

export default SearchInput;
